// extracted by mini-css-extract-plugin
export var active = "_sa-1";
export var circle = "_sa-0";
export var completed = "_sa-2";
export var connector = "_sa-4";
export var connectorCompleted = "_sa-7";
export var connectorSpacer = "_sa-5";
export var iconStrokeOverride = "_sa-8";
export var labelContainer = "_sa-6";
export var pending = "_sa-3";